import React, { useState } from "react";
import {
  fieldContainer,
  fieldControlBase,
  fieldErrorText,
  fieldLabel,
} from "./inputTheme";

const states = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "MG",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP",
  "SE",
  "TO",
];

const StateSelectInput = ({
  setState,
  stateValue = "",
  className = "",
  label = "Estado",
  disabled = false,
  error,
}) => {
  const handleChange = (event) => {
    setState(event.target.value);
  };

  return (
    <div className={`${fieldContainer} ${className}`}>
      <label className={fieldLabel}>{label}</label>
      <select
        className={fieldControlBase}
        onChange={handleChange}
        value={stateValue}
        disabled={disabled}
      >
        <option value="">-</option>
        {states.map((state) => (
          <option key={state} value={state}>
            {state}
          </option>
        ))}
      </select>
      {error && <small className={fieldErrorText}>{error}</small>}
    </div>
  );
};

export default StateSelectInput;
